componentRegistryInstance.register('canvas', 'read', 'hrd.components.form.CanvasComponent');

hrd.components.form.CanvasComponent = hrd.components.AbstractFieldComponent.extend({
	init: function(options) {
		var defaults = {
			impl: 'hrd.components.form.CanvasComponent',
		};
		this._super($.extend(true, {}, defaults, options));
	},
	enhanceReadField: function(field, id, klass) {
		this._super(field, id, klass);
		let sCanvas = field.data('canvas');
		if (sCanvas != undefined) {
			let canvasInfo = $.evaluate(sCanvas, this.settings.reference);
			canvasInfo.id = id + '-canvas';
			field.data('canvasInfo', canvasInfo);
			let $canvas = $(`<canvas id="${canvasInfo.id}" width="${canvasInfo.width || 300}" height="${canvasInfo.height || 150}"></canvas>`);
			field.append($canvas); // check if canvas not already added
		} else {
			console.log('data-canvas is missing');
		}
	},
	getReadOnlyField: function(field, name, object, options) {
		this._super(field, name, object, options);
	},
	setReadOnlyField: function(field, value, object, options) {
		let canvasInfo = field.data('canvasInfo');
		if (canvasInfo != undefined) {
			let canvasOptions;
			let dynamicOptions = field.data('canvasDynamicOptions');
			if (dynamicOptions == true) {
				let dynamicOptionsFn = $.functionCase(field.data('name') + '-canvas-options');
				if (typeof this.settings.reference[dynamicOptionsFn] === 'function') {
					canvasOptions = this.settings.reference[dynamicOptionsFn].call(this.settings.reference, value, field, object, this.getFormInstance());
				} else {
					console.log(`CanvasOptions function NOT available. Add "${dynamicOptionsFn}" in "${(this.settings.reference._FULL_ ? this.settings.reference._FULL_ : this.settings.reference.PANEL_ID)}"`);
					canvasOptions = canvasInfo;
				}
			} else {
				canvasOptions = canvasInfo;
			}
			let prevVal = field.data('used-value');
			if (prevVal != value) {
				field.data('used-value', value);
				switch (canvasInfo.type) {
					case 'circularLabel':
						canvasUtils.circularLabel(canvasInfo.id, value, canvasOptions);
						break;
					case 'progressMeter':
						if (canvasInfo.incremental == true) {
							canvasUtils.progressMeter(canvasInfo.id, prevVal, value, canvasOptions);
						} else {
							canvasUtils.progressMeter(canvasInfo.id, 0, value, canvasOptions);
						}
						break;
					default:
						break;
				}
			}
		}
	},
	resetReadOnlyField: function(field, options) {
		let canvasInfo = field.data('canvasInfo');
		if (canvasInfo != undefined) {
			let canvasOptions;
			let dynamicOptions = field.data('canvasDynamicOptions');
			if (dynamicOptions == true) {
				let dynamicOptionsFn = $.functionCase(field.data('name') + '-canvas-options');
				if (typeof this.settings.reference[dynamicOptionsFn] === 'function') {
					canvasOptions = this.settings.reference[dynamicOptionsFn].call(this.settings.reference, 0, field, {}, this.getFormInstance());
				} else {
					console.log(`CanvasOptions function NOT available. Add "${dynamicOptionsFn}" in "${(this.settings.reference._FULL_ ? this.settings.reference._FULL_ : this.settings.reference.PANEL_ID)}"`);
					canvasOptions = canvasInfo;
				}
			} else {
				canvasOptions = canvasInfo;
			}
			// remove previously used value, 
			field.removeData('used-value');

			switch (canvasInfo.type) {
				case 'circularLabel':
					canvasUtils.circularLabel(canvasInfo.id, undefined, canvasOptions);
					break;
				case 'progressMeter':
					canvasUtils.progressMeter(canvasInfo.id, undefined, undefined, canvasOptions);
					break;
				default:
					break;
			}
		}
	}
});